import React from "react";
import { Box, MainCard, MainText } from "app/components/common";
import RiseUp from "app/components/Icons/Arrow/RiseUp";
import theme from "app/Theme/Theme";
import normalize from "app/utils/normalize";

interface IProps {
  stat: React.ReactElement;
  progress: React.ReactElement;
  description: string;
}

const InformativeCard = ({ stat, progress, description }: IProps) => {
  return (
    <MainCard
      variant="informationCard"
      zIndex={0}
      height={normalize(90)}
      justifyContent="space-between"
    >
      <Box
        flexDirection="row"
        marginBottom="xxs"
        alignItems="center"
        justifyContent="space-between"
        flex={1}
      >
        {stat}
        <RiseUp
          width={normalize(22)}
          height={normalize(22)}
          color={theme.colors["system.green.900"]}
        />
      </Box>
      <MainText variant="l3-medium" color="neutral.600" marginBottom="xs">
        {description}
      </MainText>
      {progress}
    </MainCard>
  );
};

export default InformativeCard;
